import { checkout_item_container } from './index.styles';

interface Props {
  children: React.ReactNode;
  id?: string;
}

export const CheckoutItemContainer = ({ children, id }: Props) => {
  return (
    <div css={checkout_item_container} id={id || undefined}>
      {children}
    </div>
  );
};
